export default __webpack_public_path__ + "images/885cab8c762d17c70c11d259433e9145-1_tablet_1067x470.webp";